<template>
  <div class="c-onboarding-steps">
    <template v-for="step in steps">
      <div
        v-if="step.number > 1"
        :class="getStepClasses(step.number)"
        class="c-onboarding-steps__separator"
      ></div>
      <div class="c-onboarding-steps__item">
        <div
          class="c-onboarding-steps__number"
          :class="getStepClasses(step.number)"
        >
          {{ step.number }}
        </div>
        <div class="c-onboarding-steps__label">
          {{ step.label }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        steps: [{
          number: 1,
          label: this.$t('views.onboarding.details'),
        }, {
          number: 2,
          label: this.$t('views.onboarding.verification'),
        }, {
          number: 3,
          label: this.$t('views.onboarding.password'),
        }],
      };
    },
    computed: {
      currentStep() {
        return this.$route.meta.onboardingStep;
      },
    },
    methods: {
      getStepClasses(step) {
        return {
          'is-half': this.currentStep > step - 1 && this.currentStep < step,
          'is-full': this.currentStep >= step,
        };
      },
    },
  };
</script>
